import React, { useEffect, useState } from 'react';
import { Icon } from '../../assets/icons';
import PhoneVerifyIllustration from '../../assets/images/phone-verify.svg'; // Placeholder
import { useTheme } from '../../context/themeProvider';
import GlobalModal from '../../molecules/GlobalModal';

const PhoneVerifyModal = ({ opened, onClose, onVerifyNow }) => {
  const { colorScheme } = useTheme();
  const isDarkTheme = colorScheme === 'dark';
  // Calculate the countdown based on the target date
  const targetDate = new Date('2025-05-20T18:30:00Z');
  const [countdown, setCountdown] = useState(
    Math.floor((targetDate - new Date()) / 1000)
  );

  useEffect(() => {
    if (!opened) return;
    if (countdown <= 0) return;
    const interval = setInterval(() => {
      setCountdown((c) => (c > 0 ? c - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, [opened, countdown]);

  const formatCountdown = (sec) => {
    const d = Math.floor(sec / (24 * 3600));
    const h = Math.floor((sec % (24 * 3600)) / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;
    return `${d.toString().padStart(2, '0')} days, ${h.toString().padStart(2, '0')}:${m
      .toString()
      .padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };

  return (
    <GlobalModal opened={opened} onClose={onClose}>
      <div className='flex flex-col items-center px-6 pb-6 pt-2'>
        {/* Replace with actual illustration */}
        <div className='mb-4 flex h-[200px] w-full items-center justify-center rounded-lg'>
          <img
            src={PhoneVerifyIllustration}
            alt='WhatsApp bg'
            className='h-full w-full rounded-lg object-cover'
          />
        </div>
        <h2 className='mb-2 text-center text-poppins-semibold-18 font-bold text-text'>
          Please Verify your Phone Number
        </h2>
        <p
          className={`mb-4 text-center text-poppins-14 ${isDarkTheme ? 'text-[#B9B9B9]' : 'text-[#747474]'}`}
        >
          We're removing Google login soon! To keep your account secure and
          accessible, verify your phone number via WhatsApp.
        </p>
        <div
          className={`mb-6 w-full flex-col items-center justify-center gap-4 rounded-lg ${
            isDarkTheme ? 'bg-[#D953533D]' : 'bg-[#FDECEC]'
          } p-3 text-center text-poppins-medium-14 text-text`}
        >
          <div className='flex items-center justify-center gap-2'>
            <span>
              <Icon name={isDarkTheme ? 'timer-dark' : 'timer'} size='md' />
            </span>
            <span>You'll lose access to your account in</span>
          </div>
          <div className='align-middle text-[#E05A47]'>
            {formatCountdown(countdown)}
          </div>
        </div>
        <button
          className={`mb-3 w-full rounded-full ${
            isDarkTheme ? 'bg-white text-[#070519]' : 'bg-[#070519] text-white'
          } py-3 text-base font-bold transition`}
          onClick={onVerifyNow}
        >
          Verify Now
        </button>
        <button
          className={`w-full rounded-full border-2 py-3 text-base font-bold transition ${
            isDarkTheme
              ? 'border-white bg-[#23232a] text-white'
              : 'border-[#23232a] bg-white text-[#070519]'
          }`}
          onClick={onClose}
        >
          I'll verify later
        </button>
      </div>
    </GlobalModal>
  );
};

export default PhoneVerifyModal;
